<template>
  <div class="hold-transition perfil-page">
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header perfil-hero-wrap">
          <div class="container-fluid">
            <div class="perfil-hero">
              <div class="perfil-hero__main">
                <div
                  class="perfil-avatar"
                  aria-hidden="true"
                >
                  {{ iniciales }}
                </div>
                <div class="perfil-hero__copy">
                  <p class="perfil-hero__eyebrow mb-1">Mi perfil</p>
                  <h4 class="perfil-hero__name mb-1">
                    {{ (usuario && usuario.name) || "Usuario" }}
                  </h4>
                  <p class="perfil-hero__meta mb-2">
                    {{ (usuario && usuario.email) || "—" }}
                    <span
                      v-if="usuario && usuario.cargo"
                      class="perfil-dot"
                      >·</span
                    >
                    <span v-if="usuario && usuario.cargo">{{
                      usuario.cargo
                    }}</span>
                  </p>
                  <div class="perfil-hero__badges">
                    <span
                      class="perfil-pill"
                      :class="
                        usuario && usuario.two_factor_enabled
                          ? 'is-ok'
                          : 'is-muted'
                      "
                    >
                      <i class="fas fa-shield-alt mr-1"></i>
                      {{
                        usuario && usuario.two_factor_enabled
                          ? "2FA activo"
                          : "2FA obligatorio"
                      }}
                    </span>
                    <span
                      v-if="usuario && usuario.two_factor_app"
                      class="perfil-pill is-info"
                      >App</span
                    >
                    <span
                      v-if="usuario && usuario.two_factor_email"
                      class="perfil-pill is-info"
                      >Correo</span
                    >
                    <span
                      v-if="perfilCambioSinGuardar"
                      class="perfil-pill is-warn"
                      >Cambios sin guardar</span
                    >
                  </div>
                </div>
              </div>
              <div class="perfil-hero__actions">
                <template v-if="!requiresTwoFactorSetup">
                  <ol
                    class="breadcrumb mb-2 mb-md-3 bg-transparent p-0 justify-content-md-end"
                  >
                    <li class="breadcrumb-item">
                      <router-link to="/">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active">Perfil</li>
                  </ol>
                  <router-link
                    to="/"
                    class="btn btn-sm btn-outline-light perfil-back-btn"
                  >
                    <i class="fas fa-arrow-left mr-1"></i> Volver
                  </router-link>
                </template>
                <button
                  v-else
                  type="button"
                  class="btn btn-sm btn-outline-light perfil-back-btn"
                  :disabled="cerrandoSesion"
                  @click="cerrarSesion"
                >
                  <i class="fas fa-sign-out-alt mr-1"></i> Cerrar sesión
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="content pb-4">
          <div class="container-fluid">
            <div
              v-if="!usuario"
              class="perfil-card text-center text-muted py-5"
            >
              Cargando…
            </div>

            <template v-else>
              <div
                v-if="requiresTwoFactorSetup"
                class="alert alert-warning perfil-2fa-required mb-4"
                role="alert"
              >
                <div class="d-flex align-items-start">
                  <i class="fas fa-exclamation-triangle mr-2 mt-1"></i>
                  <div>
                    <strong>Doble autenticación obligatoria</strong>
                    <p class="mb-0 small">
                      Debe activar al menos un método (app o correo) para
                      continuar usando el sistema. Mientras no lo configure, no
                      podrá navegar a otras secciones.
                    </p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-7 mb-4">
                  <div class="perfil-card h-100">
                    <div class="perfil-card__head">
                      <span class="perfil-card__icon"
                        ><i class="fas fa-user"></i
                      ></span>
                      <div>
                        <h6 class="mb-0 font-weight-bold">Datos personales</h6>
                        <p class="small text-muted mb-0">
                          Nombre y cargo los puede editar usted.
                        </p>
                      </div>
                    </div>
                    <div class="perfil-card__body">
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="perfil-name">Nombre completo</label>
                          <input
                            id="perfil-name"
                            v-model.trim="perfil.name"
                            type="text"
                            class="form-control perfil-input"
                            maxlength="255"
                            autocomplete="name"
                            placeholder="Su nombre como aparecerá en el sistema"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="perfil-cargo">Cargo (texto libre)</label>
                          <input
                            id="perfil-cargo"
                            v-model.trim="perfil.cargo"
                            type="text"
                            class="form-control perfil-input"
                            maxlength="191"
                            autocomplete="organization-title"
                            placeholder="Ej. Coordinador de tráfico…"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="perfil-cargo-firma"
                            >Cargo para firmas</label
                          >
                          <select
                            id="perfil-cargo-firma"
                            v-model="perfil.cargo_firma"
                            class="form-control perfil-input"
                          >
                            <option :value="null">Seleccione…</option>
                            <option
                              v-for="cargo in cargosFirmas"
                              :key="cargo.numeracion"
                              :value="cargo.numeracion"
                            >
                              {{ cargo.descripcion }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="perfil-readonly-grid">
                        <div class="perfil-readonly-item">
                          <span class="perfil-readonly-label"
                            >Correo electrónico</span
                          >
                          <div class="perfil-readonly">
                            {{ usuario.email || "—" }}
                          </div>
                          <small class="form-text text-muted mb-0">
                            Solo un administrador puede cambiarlo.
                          </small>
                        </div>
                        <div class="perfil-readonly-item">
                          <span class="perfil-readonly-label"
                            >Cédula / documento</span
                          >
                          <div class="perfil-readonly">
                            {{ textoDocumento }}
                          </div>
                          <small class="form-text text-muted mb-0">
                            Dato de identificación (solo lectura).
                          </small>
                        </div>
                      </div>

                      <div class="perfil-actions mt-4">
                        <button
                          type="button"
                          class="btn btn-perfil-primary"
                          :disabled="guardandoPerfil || !puedeGuardarPerfil"
                          @click="guardarPerfil"
                        >
                          <span
                            v-if="guardandoPerfil"
                            class="spinner-border spinner-border-sm mr-2"
                            role="status"
                          />
                          Guardar cambios
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-5 mb-4">
                  <div class="perfil-card h-100">
                    <div class="perfil-card__head">
                      <span class="perfil-card__icon perfil-card__icon--accent">
                        <i class="fas fa-signature"></i>
                      </span>
                      <div>
                        <h6 class="mb-0 font-weight-bold">Firma en correos</h6>
                        <p class="small text-muted mb-0">
                          PNG, JPG, GIF o WebP · máx. 4&nbsp;MB
                        </p>
                      </div>
                    </div>
                    <div class="perfil-card__body">
                      <p class="small text-muted">
                        Se adjunta al final del mensaje en informes y envíos que
                        usen su perfil.
                      </p>
                      <div
                        v-if="usuario.firma_correo_imagen_url"
                        class="perfil-firma-wrap mb-3"
                      >
                        <span class="small text-muted d-block mb-1"
                          >Vista previa</span
                        >
                        <img
                          :src="usuario.firma_correo_imagen_url"
                          alt="Firma"
                          class="perfil-firma-preview"
                        />
                      </div>
                      <div
                        v-else
                        class="perfil-firma-placeholder mb-3"
                      >
                        <i class="far fa-image fa-2x mb-2 d-block"></i>
                        <span class="small"
                          >Aún no tiene imagen de firma configurada.</span
                        >
                      </div>
                      <div class="d-flex flex-column flex-sm-row flex-wrap">
                        <button
                          type="button"
                          class="btn btn-perfil-outline mb-2 mb-sm-0 mr-sm-2"
                          :disabled="subiendo"
                          @click="abrirModalSubirFirma"
                        >
                          <i class="fas fa-upload mr-1"></i>
                          {{
                            usuario.firma_correo_imagen_url
                              ? "Cambiar firma"
                              : "Agregar firma"
                          }}
                        </button>
                        <button
                          v-if="usuario.firma_correo_imagen_url"
                          type="button"
                          class="btn btn-perfil-danger"
                          :disabled="subiendo"
                          @click="abrirModalQuitarFirma"
                        >
                          <i class="fas fa-trash-alt mr-1"></i>
                          Quitar firma
                        </button>
                      </div>
                      <p class="perfil-secure-note mt-3 mb-0">
                        <i class="fas fa-lock mr-1"></i>
                        Para agregar, cambiar o quitar la firma debe confirmar
                        su contraseña.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 mb-4">
                  <div class="perfil-card h-100">
                    <div class="perfil-card__head">
                      <span class="perfil-card__icon perfil-card__icon--docs">
                        <i class="fas fa-file-signature"></i>
                      </span>
                      <div>
                        <h6 class="mb-0 font-weight-bold">
                          Firmas de documentos
                        </h6>
                        <p class="small text-muted mb-0">
                          Para paquetes y procesos con firma gráfica.
                        </p>
                      </div>
                    </div>
                    <div class="perfil-card__body">
                      <div
                        v-if="cargandoFirmasDoc"
                        class="text-muted small py-2"
                      >
                        <span class="spinner-border spinner-border-sm mr-2" />
                        Cargando firmas…
                      </div>
                      <div
                        v-else-if="firmaDocActiva"
                        class="d-flex flex-wrap align-items-center mb-3"
                      >
                        <div class="perfil-firma-wrap mr-3 mb-2 mb-md-0">
                          <span class="small text-muted d-block mb-1"
                            >Firma activa</span
                          >
                          <img
                            :src="firmaDocActiva.url"
                            :alt="firmaDocActiva.alias || 'Firma'"
                            class="perfil-firma-preview"
                          />
                        </div>
                        <div>
                          <div class="font-weight-bold">
                            {{ firmaDocActiva.alias || "Sin nombre" }}
                          </div>
                          <span class="perfil-pill is-muted text-uppercase">
                            {{ firmaDocActiva.metodo }}
                          </span>
                          <span class="small text-muted ml-2">
                            {{ firmasDoc.length }} guardada(s)
                          </span>
                        </div>
                      </div>
                      <div
                        v-else
                        class="perfil-firma-placeholder mb-3"
                      >
                        <i class="fas fa-file-signature fa-2x mb-2 d-block"></i>
                        <span class="small">
                          Aún no tiene firmas para documentos.
                        </span>
                      </div>
                      <button
                        type="button"
                        class="btn btn-perfil-outline"
                        @click="mostrarModalFirmasDoc = true"
                      >
                        <i class="fas fa-pen-nib mr-1"></i>
                        {{
                          firmaDocActiva ? "Administrar firmas" : "Crear firma"
                        }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-4">
                  <div class="perfil-card h-100">
                    <div class="perfil-card__head">
                      <span class="perfil-card__icon perfil-card__icon--2fa">
                        <i class="fas fa-shield-alt"></i>
                      </span>
                      <div>
                        <h6 class="mb-0 font-weight-bold">
                          Doble autenticación
                        </h6>
                        <p class="small text-muted mb-0">
                          {{
                            requiresTwoFactorSetup
                              ? "Obligatorio: active al menos un método."
                              : "App, correo, o ambas opciones."
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="perfil-card__body">
                      <div
                        v-if="usuario.two_factor_enabled"
                        class="mb-3"
                      >
                        <span class="perfil-pill is-ok mr-1">Activa</span>
                        <span
                          v-if="usuario.two_factor_app"
                          class="perfil-pill is-info mr-1"
                          >App</span
                        >
                        <span
                          v-if="usuario.two_factor_email"
                          class="perfil-pill is-info"
                          >Correo</span
                        >
                      </div>

                      <div
                        v-if="twoFactorSetup"
                        class="two-factor-setup mb-3"
                      >
                        <p class="small text-muted">
                          Escanee el código QR con Google Authenticator,
                          Microsoft Authenticator u otra app compatible.
                        </p>
                        <div
                          v-if="twoFactorQr"
                          class="two-factor-qr mb-3"
                          v-html="twoFactorQr"
                        ></div>
                        <div class="form-group">
                          <label for="two-factor-confirm"
                            >Código de verificación</label
                          >
                          <input
                            id="two-factor-confirm"
                            v-model.trim="twoFactorConfirmCode"
                            type="text"
                            maxlength="6"
                            inputmode="numeric"
                            class="form-control perfil-input"
                            placeholder="000000"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-perfil-primary mr-2"
                          :disabled="
                            twoFactorLoading ||
                            twoFactorConfirmCode.length !== 6
                          "
                          @click="confirmarTwoFactor"
                        >
                          Confirmar app
                        </button>
                        <button
                          type="button"
                          class="btn btn-perfil-ghost"
                          :disabled="twoFactorLoading"
                          @click="cancelarTwoFactorSetup"
                        >
                          Cancelar
                        </button>
                      </div>

                      <div
                        v-else
                        class="d-flex flex-wrap"
                      >
                        <button
                          v-if="!usuario.two_factor_app"
                          type="button"
                          class="btn btn-perfil-outline mr-2 mb-2"
                          :disabled="twoFactorLoading"
                          @click="iniciarTwoFactor"
                        >
                          <i class="fas fa-mobile-alt mr-1"></i>
                          Activar con app
                        </button>
                        <button
                          v-if="!usuario.two_factor_email"
                          type="button"
                          class="btn btn-perfil-outline mb-2"
                          :disabled="twoFactorLoading"
                          @click="activarTwoFactorEmail"
                        >
                          <i class="fas fa-envelope mr-1"></i>
                          Activar con correo
                        </button>
                      </div>

                      <div
                        v-if="twoFactorRecoveryCodes.length"
                        class="alert alert-warning mt-3 mb-0"
                      >
                        <strong>Guarde estos códigos de recuperación.</strong>
                        <p class="small mb-2">
                          Úselos si pierde acceso a la app o al correo. Cada
                          código sirve una sola vez.
                        </p>
                        <ul class="mb-0 pl-3 small">
                          <li
                            v-for="code in twoFactorRecoveryCodes"
                            :key="code"
                          >
                            {{ code }}
                          </li>
                        </ul>
                      </div>

                      <div
                        v-if="usuario.two_factor_enabled"
                        class="mt-3 d-flex flex-wrap"
                      >
                        <button
                          v-if="usuario.two_factor_email"
                          type="button"
                          class="btn btn-perfil-ghost btn-sm mr-2 mb-2"
                          :disabled="twoFactorLoading"
                          @click="desactivarTwoFactorEmail"
                        >
                          Quitar correo
                        </button>
                        <button
                          v-if="usuario.two_factor_app"
                          type="button"
                          class="btn btn-perfil-ghost btn-sm mr-2 mb-2"
                          :disabled="twoFactorLoading"
                          @click="desactivarTwoFactorApp"
                        >
                          Quitar app
                        </button>
                        <button
                          type="button"
                          class="btn btn-perfil-danger btn-sm mb-2"
                          :disabled="twoFactorLoading"
                          @click="desactivarTwoFactor"
                        >
                          Desactivar todo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>

    <div
      v-if="modalSubir.mostrar"
      class="perfil-modal-backdrop"
      @click.self="cerrarModalSubir"
    >
      <div
        class="perfil-modal"
        role="dialog"
        aria-labelledby="modal-firma-titulo"
      >
        <h6
          id="modal-firma-titulo"
          class="font-weight-bold mb-3"
        >
          {{
            usuario && usuario.firma_correo_imagen_url
              ? "Cambiar imagen de firma"
              : "Agregar imagen de firma"
          }}
        </h6>
        <p class="small text-muted mb-3">
          Ingrese su contraseña actual y elija la imagen. Así confirmamos que es
          usted quien modifica la firma.
        </p>
        <div class="form-group">
          <label for="pwd-firma">Contraseña actual</label>
          <input
            id="pwd-firma"
            v-model="modalSubir.password"
            type="password"
            class="form-control perfil-input"
            autocomplete="current-password"
            placeholder="••••••••"
            @keyup.enter="confirmarSubirFirma"
          />
        </div>
        <div class="form-group">
          <label for="file-firma-modal">Imagen</label>
          <input
            id="file-firma-modal"
            ref="inputFirmaModal"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/webp"
            class="form-control-file"
            @change="onFileFirmaModal"
          />
          <small
            v-if="modalSubir.nombreArchivo"
            class="form-text text-muted"
          >
            {{ modalSubir.nombreArchivo }}
          </small>
        </div>
        <div class="d-flex justify-content-end flex-wrap mt-4">
          <button
            type="button"
            class="btn btn-perfil-ghost mr-2"
            @click="cerrarModalSubir"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-perfil-primary"
            :disabled="subiendo"
            @click="confirmarSubirFirma"
          >
            <span
              v-if="subiendo"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
            />
            Guardar firma
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="modalQuitar.mostrar"
      class="perfil-modal-backdrop"
      @click.self="cerrarModalQuitar"
    >
      <div
        class="perfil-modal"
        role="dialog"
        aria-labelledby="modal-quitar-titulo"
      >
        <h6
          id="modal-quitar-titulo"
          class="font-weight-bold mb-3"
        >
          Quitar firma
        </h6>
        <p class="small text-muted mb-3">
          Se eliminará la imagen usada en correos. Confirme con su contraseña
          actual.
        </p>
        <div class="form-group mb-0">
          <label for="pwd-quitar">Contraseña actual</label>
          <input
            id="pwd-quitar"
            v-model="modalQuitar.password"
            type="password"
            class="form-control perfil-input"
            autocomplete="current-password"
            placeholder="••••••••"
            @keyup.enter="confirmarQuitarFirma"
          />
        </div>
        <div class="d-flex justify-content-end flex-wrap mt-4">
          <button
            type="button"
            class="btn btn-perfil-ghost mr-2"
            @click="cerrarModalQuitar"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-perfil-danger"
            :disabled="subiendo"
            @click="confirmarQuitarFirma"
          >
            <span
              v-if="subiendo"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
            />
            Quitar firma
          </button>
        </div>
      </div>
    </div>

    <FirmaDocumentoModal
      :visible="mostrarModalFirmasDoc"
      @close="mostrarModalFirmasDoc = false"
      @saved="cargarFirmasDocumento"
    />
  </div>
</template>

<script>
import axios from "axios";
import FirmaDocumentoModal from "../components/FirmaDocumentoModal.vue";

export default {
  name: "PerfilUsuario",
  components: {
    FirmaDocumentoModal,
  },
  data() {
    return {
      perfil: { name: "", cargo: "", cargo_firma: null },
      perfilInicial: { name: "", cargo: "", cargo_firma: null },
      cargosFirmas: [],
      guardandoPerfil: false,
      subiendo: false,
      modalSubir: {
        mostrar: false,
        password: "",
        archivo: null,
        nombreArchivo: "",
      },
      modalQuitar: {
        mostrar: false,
        password: "",
      },
      mostrarModalFirmasDoc: false,
      firmasDoc: [],
      cargandoFirmasDoc: false,
      twoFactorSetup: false,
      twoFactorQr: "",
      twoFactorConfirmCode: "",
      twoFactorRecoveryCodes: [],
      twoFactorLoading: false,
      cerrandoSesion: false,
    };
  },
  computed: {
    usuario() {
      return this.$store.state.user;
    },
    requiresTwoFactorSetup() {
      return this.$store.getters.requiresTwoFactorSetup;
    },
    textoDocumento() {
      const u = this.usuario;
      if (!u) return "—";
      const n = u.n_document;
      if (n === null || n === undefined || String(n).trim() === "") return "—";
      return String(n);
    },
    perfilCambioSinGuardar() {
      return (
        this.perfil.name !== this.perfilInicial.name ||
        (this.perfil.cargo || "") !== (this.perfilInicial.cargo || "") ||
        Number(this.perfil.cargo_firma || 0) !==
          Number(this.perfilInicial.cargo_firma || 0)
      );
    },
    puedeGuardarPerfil() {
      return (this.perfil.name || "").length > 0;
    },
    firmaDocActiva() {
      return this.firmasDoc.find((f) => f.activa) || this.firmasDoc[0] || null;
    },
    iniciales() {
      const name = ((this.usuario && this.usuario.name) || "").trim();
      if (!name) return "U";
      const parts = name.split(/\s+/).filter(Boolean);
      const a = parts[0] ? parts[0][0] : "U";
      const b = parts.length > 1 ? parts[1][0] : parts[0][1] || "";
      return (a + b).toUpperCase();
    },
  },
  watch: {
    usuario: {
      immediate: true,
      handler(u) {
        if (!u) return;
        this.perfil = {
          name: u.name || "",
          cargo: u.cargo || "",
          cargo_firma: u.cargo_firma != null ? Number(u.cargo_firma) : null,
        };
        this.perfilInicial = { ...this.perfil };
      },
    },
  },
  mounted() {
    if (!this.$store.state.user) {
      this.$store.dispatch("getUser");
    }
    this.cargarFirmasDocumento();
    this.cargarCargosFirmas();
  },
  methods: {
    async cargarCargosFirmas() {
      try {
        const { data } = await axios.get("/api/lista/CF");
        this.cargosFirmas = Array.isArray(data) ? data : [];
      } catch (e) {
        this.cargosFirmas = [];
      }
    },
    async cargarFirmasDocumento() {
      this.cargandoFirmasDoc = true;
      try {
        const { data } = await axios.get("/api/user/firmas");
        this.firmasDoc = Array.isArray(data) ? data : [];
      } catch (e) {
        this.firmasDoc = [];
      } finally {
        this.cargandoFirmasDoc = false;
      }
    },
    mensajeError(e) {
      if (!e || !e.response) {
        return e && e.message
          ? `No se pudo completar la operación (${e.message}).`
          : "No se pudo completar la operación. Verifique la conexión con el servidor.";
      }
      const status = e.response.status;
      const d = e.response.data;
      if (d && typeof d.message === "string" && d.message.trim()) {
        return d.message;
      }
      if (d && d.errors) {
        const first = Object.values(d.errors)[0];
        return Array.isArray(first) ? first[0] : String(first);
      }
      if (typeof d === "string" && /Cannot (GET|POST|PUT|DELETE)/i.test(d)) {
        return "El proxy de desarrollo no reenvía esta ruta. Reinicie npm run serve.";
      }
      if (status === 419) {
        return "La sesión de seguridad expiró. Recargue la página e inténtelo de nuevo.";
      }
      if (status === 401) {
        return "Sesión no válida. Vuelva a iniciar sesión.";
      }
      return `No se pudo completar la operación (HTTP ${status}).`;
    },
    async guardarPerfil() {
      if (!this.puedeGuardarPerfil) return;
      this.guardandoPerfil = true;
      try {
        await axios.patch("/api/user/perfil", {
          name: this.perfil.name,
          cargo: this.perfil.cargo || null,
          cargo_firma: this.perfil.cargo_firma || null,
        });
        await this.$store.dispatch("getUser");
        this.perfilInicial = { ...this.perfil };
        this.$swal({
          icon: "success",
          title: "Perfil actualizado",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.guardandoPerfil = false;
      }
    },
    abrirModalSubirFirma() {
      this.modalSubir = {
        mostrar: true,
        password: "",
        archivo: null,
        nombreArchivo: "",
      };
      this.$nextTick(() => {
        const el = this.$refs.inputFirmaModal;
        if (el) el.value = "";
      });
    },
    cerrarModalSubir() {
      this.modalSubir.mostrar = false;
      this.modalSubir.password = "";
      this.modalSubir.archivo = null;
      this.modalSubir.nombreArchivo = "";
    },
    onFileFirmaModal(ev) {
      const input = ev && ev.target;
      const file = input && input.files && input.files[0];
      this.modalSubir.archivo = file || null;
      this.modalSubir.nombreArchivo = file ? file.name : "";
    },
    async confirmarSubirFirma() {
      if (!this.modalSubir.password) {
        this.$swal({ icon: "warning", title: "Ingrese su contraseña actual." });
        return;
      }
      if (!this.modalSubir.archivo) {
        this.$swal({
          icon: "warning",
          title: "Seleccione un archivo de imagen.",
        });
        return;
      }
      this.subiendo = true;
      const fd = new FormData();
      fd.append("current_password", this.modalSubir.password);
      fd.append("firma_imagen", this.modalSubir.archivo);
      try {
        await axios.post("/api/user/firma-correo-imagen", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        await this.$store.dispatch("getUser");
        this.cerrarModalSubir();
        this.$swal({
          icon: "success",
          title: "Firma actualizada",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.subiendo = false;
      }
    },
    async iniciarTwoFactor() {
      this.twoFactorLoading = true;
      try {
        await axios.post("/user/two-factor-authentication");
        const { data } = await axios.get("/user/two-factor-qr-code");
        this.twoFactorQr = data && data.svg ? data.svg : "";
        this.twoFactorSetup = true;
        this.twoFactorConfirmCode = "";
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    cancelarTwoFactorSetup() {
      this.twoFactorSetup = false;
      this.twoFactorQr = "";
      this.twoFactorConfirmCode = "";
    },
    async confirmarTwoFactor() {
      if (this.twoFactorConfirmCode.length !== 6) return;
      this.twoFactorLoading = true;
      try {
        await axios.post("/user/confirmed-two-factor-authentication", {
          code: this.twoFactorConfirmCode,
        });
        const { data } = await axios.get("/user/two-factor-recovery-codes");
        this.twoFactorRecoveryCodes = Array.isArray(data) ? data : [];
        this.twoFactorSetup = false;
        this.twoFactorQr = "";
        this.twoFactorConfirmCode = "";
        const eraObligatorio = this.requiresTwoFactorSetup;
        await this.$store.dispatch("getUser");
        this.$swal({
          icon: "success",
          title: "Doble autenticación activada",
          text: eraObligatorio
            ? "Guarde los códigos de recuperación. Ya puede navegar por el sistema."
            : "Guarde los códigos de recuperación en un lugar seguro.",
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    async activarTwoFactorEmail() {
      this.twoFactorLoading = true;
      try {
        const { data } = await axios.post("/user/two-factor-email");
        this.twoFactorRecoveryCodes = Array.isArray(data.recovery_codes)
          ? data.recovery_codes
          : [];
        const eraObligatorio = this.requiresTwoFactorSetup;
        await this.$store.dispatch("getUser");
        this.$swal({
          icon: "success",
          title: "2FA por correo activado",
          text: eraObligatorio
            ? "Ya puede navegar por el sistema. Guarde los códigos de recuperación si se muestran."
            : this.twoFactorRecoveryCodes.length
            ? "Guarde los códigos de recuperación en un lugar seguro."
            : "Cuando cambie su IP, recibirá un código en su correo.",
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    async desactivarTwoFactorEmail() {
      const esUltimo =
        this.usuario.two_factor_email && !this.usuario.two_factor_app;
      const confirm = await this.$swal({
        icon: "warning",
        title: "¿Quitar verificación por correo?",
        text: esUltimo
          ? "Quedará sin doble autenticación y deberá configurarla de nuevo para usar el sistema."
          : undefined,
        showCancelButton: true,
        confirmButtonText: "Quitar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      this.twoFactorLoading = true;
      try {
        await axios.delete("/user/two-factor-email");
        this.twoFactorRecoveryCodes = [];
        await this.$store.dispatch("getUser");
        this.$swal({
          icon: "success",
          title: "Correo desactivado",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    async desactivarTwoFactorApp() {
      const esUltimo =
        this.usuario.two_factor_app && !this.usuario.two_factor_email;
      const confirm = await this.$swal({
        icon: "warning",
        title: "¿Quitar verificación por app?",
        text: esUltimo
          ? "Quedará sin doble autenticación y deberá configurarla de nuevo para usar el sistema."
          : undefined,
        showCancelButton: true,
        confirmButtonText: "Quitar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      this.twoFactorLoading = true;
      try {
        await axios.delete("/user/two-factor-authentication");
        this.twoFactorRecoveryCodes = [];
        await this.$store.dispatch("getUser");
        this.$swal({
          icon: "success",
          title: "App desactivada",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    async desactivarTwoFactor() {
      const confirm = await this.$swal({
        icon: "warning",
        title: "¿Desactivar toda la doble autenticación?",
        text: "Se quitarán app y correo. Deberá configurar al menos un método de nuevo para seguir usando el sistema.",
        showCancelButton: true,
        confirmButtonText: "Desactivar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      this.twoFactorLoading = true;
      try {
        await axios.delete("/user/two-factor-all");
        this.twoFactorRecoveryCodes = [];
        await this.$store.dispatch("getUser");
        this.$swal({
          icon: "success",
          title: "Doble autenticación desactivada",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.twoFactorLoading = false;
      }
    },
    async cerrarSesion() {
      if (this.cerrandoSesion) return;
      this.cerrandoSesion = true;
      try {
        await this.$store.dispatch("logout");
        this.$router.replace({ name: "LoginForm" });
      } finally {
        this.cerrandoSesion = false;
      }
    },
    abrirModalQuitarFirma() {
      this.modalQuitar = { mostrar: true, password: "" };
    },
    cerrarModalQuitar() {
      this.modalQuitar.mostrar = false;
      this.modalQuitar.password = "";
    },
    async confirmarQuitarFirma() {
      if (!this.modalQuitar.password) {
        this.$swal({ icon: "warning", title: "Ingrese su contraseña actual." });
        return;
      }
      this.subiendo = true;
      try {
        await axios.delete("/api/user/firma-correo-imagen", {
          data: { current_password: this.modalQuitar.password },
        });
        await this.$store.dispatch("getUser");
        this.cerrarModalQuitar();
        this.$swal({
          icon: "success",
          title: "Firma eliminada",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
      } catch (e) {
        this.$swal({ icon: "error", title: this.mensajeError(e) });
      } finally {
        this.subiendo = false;
      }
    },
  },
};
</script>
<style scoped>
.perfil-page .content-wrapper {
  background: radial-gradient(
      1200px 420px at 10% -10%,
      rgba(21, 63, 117, 0.08),
      transparent 60%
    ),
    radial-gradient(
      900px 380px at 100% 0%,
      rgba(186, 211, 92, 0.12),
      transparent 55%
    ),
    #eef2f7;
  min-height: 100vh;
}

.perfil-hero-wrap {
  padding-top: 1rem !important;
  padding-bottom: 0.25rem !important;
}

.perfil-2fa-required {
  border: 1px solid rgba(186, 140, 40, 0.35);
  background: #fff8e8;
  color: #5c4813;
  border-radius: 12px;
}

.perfil-hero {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  padding: 1.25rem 1.35rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #153f75 0%, #0f2f58 58%, #1a4f7a 100%);
  color: #fff;
  box-shadow: 0 14px 34px rgba(15, 47, 88, 0.28);
  margin-bottom: 0.35rem;
}

.perfil-hero__main {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.perfil-avatar {
  width: 68px;
  height: 68px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.25rem;
  letter-spacing: 0.04em;
  color: #153f75;
  background: linear-gradient(145deg, #ffffff 0%, #dfe9f5 100%);
  box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.35);
  flex-shrink: 0;
}

.perfil-hero__eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.68rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.72);
}

.perfil-hero__name {
  margin: 0;
  font-weight: 800;
  font-size: 1.35rem;
  line-height: 1.2;
}

.perfil-hero__meta {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.88rem;
}

.perfil-dot {
  margin: 0 0.35rem;
}

.perfil-hero__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.perfil-hero__actions {
  text-align: right;
}

.perfil-hero__actions .breadcrumb-item,
.perfil-hero__actions .breadcrumb-item a,
.perfil-hero__actions .breadcrumb-item.active {
  color: rgba(255, 255, 255, 0.85) !important;
}

.perfil-hero__actions .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.45);
}

.perfil-back-btn {
  border-color: rgba(255, 255, 255, 0.45) !important;
  color: #fff !important;
}

.perfil-back-btn:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}

.perfil-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.22rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  border: 1px solid transparent;
}

.perfil-pill.is-ok {
  background: rgba(40, 167, 69, 0.16);
  color: #146c2e;
  border-color: rgba(40, 167, 69, 0.28);
}

.perfil-hero .perfil-pill.is-ok {
  background: rgba(186, 211, 92, 0.22);
  color: #eaf6c4;
  border-color: rgba(186, 211, 92, 0.35);
}

.perfil-pill.is-info {
  background: rgba(21, 63, 117, 0.1);
  color: #153f75;
  border-color: rgba(21, 63, 117, 0.18);
}

.perfil-hero .perfil-pill.is-info {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.22);
}

.perfil-pill.is-warn {
  background: rgba(255, 193, 7, 0.2);
  color: #8a6d00;
  border-color: rgba(255, 193, 7, 0.35);
}

.perfil-hero .perfil-pill.is-warn {
  background: rgba(255, 193, 7, 0.22);
  color: #ffe9a8;
  border-color: rgba(255, 193, 7, 0.35);
}

.perfil-pill.is-muted {
  background: #eef2f7;
  color: #5b6572;
  border-color: #d9e2ec;
}

.perfil-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(15, 47, 88, 0.08);
  border: 1px solid rgba(21, 63, 117, 0.08);
  overflow: hidden;
  height: 100%;
}

.perfil-card__head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 1.15rem 1.25rem;
  background: linear-gradient(135deg, #f8fafc 0%, #eef4fa 100%);
  border-bottom: 1px solid rgba(21, 63, 117, 0.08);
}

.perfil-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #153f75;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  flex-shrink: 0;
  box-shadow: 0 8px 18px rgba(21, 63, 117, 0.28);
}

.perfil-card__icon--accent {
  background: #1f6aa5;
}

.perfil-card__icon--docs {
  background: #1a7a5c;
}

.perfil-card__icon--2fa {
  background: #5b4b8a;
}

.perfil-card__body {
  padding: 1.25rem 1.25rem 1.4rem;
}

.perfil-input {
  border-radius: 10px !important;
  border-color: #d7dee8 !important;
  min-height: 40px;
  box-shadow: none !important;
}

.perfil-input:focus {
  border-color: #153f75 !important;
  box-shadow: 0 0 0 0.15rem rgba(21, 63, 117, 0.15) !important;
}

.perfil-readonly-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.9rem;
  margin-top: 0.35rem;
}

.perfil-readonly-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.35rem;
}

.perfil-readonly {
  padding: 0.55rem 0.8rem;
  background: #f4f7fb;
  border-radius: 10px;
  border: 1px dashed #c9d5e4;
  color: #334155;
  font-size: 0.92rem;
}

.perfil-firma-wrap {
  text-align: center;
}

.perfil-firma-preview {
  max-height: 140px;
  max-width: 100%;
  width: auto;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #d9e2ec;
  padding: 8px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(15, 47, 88, 0.06);
}

.perfil-firma-placeholder {
  text-align: center;
  padding: 1.5rem 1rem;
  background: #f7f9fc;
  border-radius: 14px;
  border: 1px dashed #c9d5e4;
  color: #6b7280;
}

.btn-perfil-primary {
  background: #153f75 !important;
  border-color: #153f75 !important;
  color: #fff !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
  min-height: 40px;
  padding: 0.45rem 1rem !important;
}

.btn-perfil-primary:hover:not(:disabled) {
  background: #0f2f58 !important;
  border-color: #0f2f58 !important;
}

.btn-perfil-outline {
  border: 1px solid #153f75 !important;
  color: #153f75 !important;
  background: #fff !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  min-height: 40px;
}

.btn-perfil-outline:hover:not(:disabled) {
  background: #153f75 !important;
  color: #fff !important;
}

.btn-perfil-ghost {
  border: 1px solid #d7dee8 !important;
  color: #475569 !important;
  background: #fff !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
}

.btn-perfil-danger {
  border: 1px solid #dc3545 !important;
  color: #dc3545 !important;
  background: #fff !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
}

.btn-perfil-danger:hover:not(:disabled) {
  background: #dc3545 !important;
  color: #fff !important;
}

.perfil-secure-note {
  font-size: 0.8rem;
  color: #1f6aa5;
  background: #eef5fb;
  border-radius: 10px;
  padding: 0.65rem 0.8rem;
}

.two-factor-qr {
  display: flex;
  justify-content: center;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5eaf0;
}

.two-factor-qr svg {
  max-width: 180px;
  height: auto;
}

.perfil-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.perfil-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 440px;
  width: 100%;
  padding: 1.4rem 1.5rem 1.3rem;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
}

@media (max-width: 767.98px) {
  .perfil-hero {
    align-items: flex-start;
  }

  .perfil-hero__actions {
    width: 100%;
    text-align: left;
  }

  .perfil-readonly-grid {
    grid-template-columns: 1fr;
  }
}
</style>
